import { FlashbarProps } from "@amzn/awsui-components-react/uxdg/flashbar/interfaces";

export function ERROR_NOTIF_ITEMS(
  message?: string
): FlashbarProps.MessageDefinition {
  return {
    type: "error",
    header: message,
    dismissible: true,
  };
}

export function IN_PROGRESS_NOTIF_ITEMS(
  header: string
): FlashbarProps.MessageDefinition {
  return {
    type: "info",
    loading: true,
    dismissible: true,
    header: header,
  };
}

export function WARNING_NOTIF_ITEMS(
  message?: string
): FlashbarProps.MessageDefinition {
  return {
    type: "warning",
    header: message,
    dismissible: true,
  };
}
